const fetch = require('isomorphic-unfetch')

let latestCheck = { version: process.env.APP_VERSION }

async function check() {
  latestCheck = await fetch('/__meta__.json').then(res => res.json())
}

export function isOnLatest() {
  return latestCheck.version === process.env.APP_VERSION
}

/*
  Periodically check for what's the latest version of App.
  This will allow us to do a hard refresh of the page in case the app gets out of sync,
  guaranteeing that we'll always have the latest version available on nagivation.
*/
setInterval(async () => {
  try {
    await check()
  } catch (e) {
    console.error(e)
  }
}, 20000)
